import LogRocket from 'logrocket';
import { IS_PROD } from '../constants/defaultValues';

if (IS_PROD) {
    LogRocket.init('c3vvsu/ozbet-ssbt');
}

export const identifyLogRocketUser = (accountNumber, customVariables) => {
    if (IS_PROD) {
        LogRocket.identify(accountNumber, {
            // Add your own custom user variables here, ie:
            ...customVariables,
        });
    }
};

// export const logRocketReduxMiddleware = [];
//
// if (IS_PROD) {
//     logRocketReduxMiddleware.push(LogRocket.reduxMiddleware());
// }
